<template>
  <router-view></router-view>
</template>

<script>
  import store from '@/store/store'
  export default {
    async beforeRouteEnter (to, from, next) {
      try {
        await Promise.all([
          store.dispatch('resetBpMeta'),
          store.dispatch('clearBpState', true),
          store.dispatch('clearFilters')
        ])
      } catch (e) {
        console.log(e)
      }
      next()
    },
    async beforeRouteLeave (to, from, next) {
      try {
        await Promise.all([
          store.dispatch('resetBpMeta'),
          store.dispatch('clearBpState', true),
          store.dispatch('clearFilters')
        ])
      } catch (e) {
        console.log(e)
      }
      next()
    }
  }
</script>
